import { useAddCommandBarStateValue } from '../command-bar-context.js';

import type { ReactNode } from 'react';

/**
 * Hook to set a custom empty state message.
 * Each element should return `null` when its search prefix is not active.
 *
 * @param message - The message to display when the command bar has no results
 * @example
 * ```tsx
 * function MyComponent() {
 *   useRegisterCommandBarEmptyMessage(<MyEmptyMessage />);
 *   return <div>My Component</div>;
 * }
 * ```
 */
export function useRegisterCommandBarEmptyMessage(message: ReactNode) {
	useAddCommandBarStateValue('emptyStateMessage', message);
}
